<template>
  <div class="d-flex flex-row" v-if="list.length > 0">
    <v-btn
      v-for="item in list"
      icon
      small
      :href="item.url"
      target="_blank"
      :key="item.url"
      @click.stop=""
    >
      <v-icon :size="iconSize" v-if="item.type === 'LinkedIn'">$vuetify.icons.linkedin</v-icon>
      <v-icon :size="iconSize" v-else-if="item.type === 'Facebook'">$vuetify.icons.facebook</v-icon>
      <v-icon :size="iconSize" v-else-if="item.type === 'Twitter'">$vuetify.icons.twitter</v-icon>
      <v-icon :size="iconSize" v-else-if="item.type === 'Instagram'"
        >$vuetify.icons.instagram
      </v-icon>
      <v-icon :size="iconSize" v-else-if="item.type === 'Youtube'">$vuetify.icons.youtube </v-icon>
      <v-icon :size="iconSize" v-else>$vuetify.icons.socialMedia</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'SocialMedia',
  props: {
    list: {
      type: Array,
      default: () => [],
      required: true,
    },
    iconSize: {
      type: Number,
      default: 20,
    },
  },
};
</script>
